// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-heading-content label, .softlite-heading-select label{
    text-transform: capitalize !important;
    font-weight: 400 !important;
    font-size: 13px !important;
}
.softlite-heading-select>div{
    width: 50%;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/block/heading/heading.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;IACI,UAAU;AACd","sourcesContent":[".softlite-heading-content label, .softlite-heading-select label{\r\n    text-transform: capitalize !important;\r\n    font-weight: 400 !important;\r\n    font-size: 13px !important;\r\n}\r\n.softlite-heading-select>div{\r\n    width: 50%;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
